import React from 'react';
import { useDispatch } from 'react-redux';
import { showFeedback } from '../../feedback/feedbackReducer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCloudExclamation } from '@fortawesome/pro-light-svg-icons';
import { SalvTooltipWrapper } from '@salvapp/ui-components';

interface Props {
  message: string;
  error?: (Response | null)[] | Response | null;
}

const DataLoadingErrorFallback = ({ message }: Props) => {
  const dispatch = useDispatch();
  dispatch(
    showFeedback({
      message,
      success: false,
    })
  );
  console.error(message);

  return (
    <div
      style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
      aria-label={'Data Loading Error Fallback'}
    >
      <SalvTooltipWrapper
        tooltip={
          <div>
            <div className={'m-b-8'}>Error: {message}</div>
            <div>Try refreshing the page. If this error persists, please contact Salv.</div>
          </div>
        }
      >
        <FontAwesomeIcon
          icon={faCloudExclamation}
          style={{
            height: '48px',
            width: '48px',
          }}
        />
      </SalvTooltipWrapper>
    </div>
  );
};

export default DataLoadingErrorFallback;
